/*global VeloxWebView*/


/**
 * Extension to display unit near the fields
 */
var extension = {} ;
extension.name = "withunit-field" ;

//must run after fields
extension.mustRunAfter = ["fields"] ;

var FIELD_UNITS = {
    "diag.d_alk": "units.mgL",
    "diag.d_hardness": "units.mgL",
    "diag.d_free_cl": "units.mgL",
    "diag.d_total_cl": "units.mgL",
    "diag.d_br": "units.mgL",
    "diag.d_salt": "units.gL",
    "diag.d_salt_disolved": "units.gL",
    "diag.d_oxygen": "units.mgL",
    "diag.d_cu": "units.mgL",
    "diag.d_fe": "units.mgL",
    "diag.d_stab": "units.mgL",
    "diag.d_temperature": "units.degC",
    "diag.d_phosphate": "units.mgL",
} ;

extension.init = function(){
    var view = this ;
    view.on("initDone", function(){
        var unitEls = [] ;
        Object.keys(FIELD_UNITS).forEach(function(k){
            unitEls = unitEls.concat(Array.prototype.slice.apply(view.viewRootEl.querySelectorAll('[data-field-def="'+k+'"]')));
        }) ;

        unitEls.forEach(function(unitEl){
            //Append the unit label to the input
            //(http://getbootstrap.com/docs/4.1/components/input-group/#basic-example)
            var inputEl = unitEl.querySelector("input") ;
            var inputGroupEl = document.createElement("DIV") ;
            inputGroupEl.className = "input-group mb-3";
            inputEl.parentElement.insertBefore(inputGroupEl, inputEl) ;
            inputGroupEl.appendChild(inputEl) ;
            var divLabelUnitEl = document.createElement("DIV") ;
            divLabelUnitEl.className = "input-group-append" ;
            var LabelEl = document.createElement("SPAN") ;
            LabelEl.className = "input-group-text" ;
            LabelEl.innerHTML = VeloxWebView.tr(FIELD_UNITS[unitEl.getAttribute("data-field-def")]) ;
            divLabelUnitEl.appendChild(LabelEl);
            inputGroupEl.appendChild(divLabelUnitEl) ;

        });
    }) ;
} ;




module.exports = extension ;